import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  IDOOHAdGroup,
  IDOOHAdGroupUpdate,
} from '@unfoldrtech/portal-mic/dist/src/openapi/core'

import { coreAPIV3 } from '../services/coreAPIV3'
import { generateCorrelationId } from '../utils/helpers'

type TPatchDoohAdGroupMutationResult = UseMutationResult<
  AxiosResponse<IDOOHAdGroup>,
  AxiosError<IError>,
  {
    payload: IDOOHAdGroupUpdate & { id: number }
  }
>

export default function usePatchDoohAdGroup(params: {
  advertiserId: number
  retailerId: number
}) {
  return useMutation(
    [`patchDoohAdGroup_${params.advertiserId}`],
    ({ payload }) => {
      const { id, ...restPayload } = payload

      return coreAPIV3
        .advertiserCampaigns()
        .patchDoohAdGroup(
          params.retailerId,
          params.advertiserId,
          id,
          generateCorrelationId(),
          restPayload
        )
    }
  ) as TPatchDoohAdGroupMutationResult
}
